module.exports = __webpack_public_path__ + "static/media/exclamation-circle.af5e654d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exclamation-circle.svg
// module id = 1923
// module chunks = 35